import React from 'react'

interface FieldItemProps {
    label: string
    value: string
    dotColor: 'yellow' | 'white'
}

const FieldItem: React.FC<FieldItemProps> = ({ label, value, dotColor }) => {
    return (
        <div className="flex flex-1 flex-col gap-[0.667rem] items-start min-w-0 rounded-[0.833rem]">
            {/* Label with dot */}
            <div className="flex gap-[0.417rem] items-center w-full">
                <div className={`rounded-full shrink-0 size-[0.625rem] ${dotColor === 'yellow' ? 'bg-[#f5e003]' : 'bg-white'}`} />
                <p className="font-['Poppins',sans-serif] font-semibold leading-normal text-[0.542rem] text-black shrink-0">{label}</p>
            </div>

            {/* Value with check */}
            <div className="flex gap-[0.417rem] items-start w-full">
                <div className="overflow-clip relative shrink-0 size-[0.667rem]">
                    <div className="absolute inset-[13.91%_0]">
                        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 16 11.5502" aria-hidden="true">
                            <path
                                d="M5.16613 11.5502C4.71195 11.5504 4.27638 11.3698 3.9555 11.0484L0.295374 7.38964C-0.098458 6.99569 -0.098458 6.35708 0.295374 5.96312C0.689332 5.56929 1.32794 5.56929 1.72189 5.96312L5.16613 9.40735L14.2781 0.295374C14.6721 -0.098458 15.3107 -0.098458 15.7046 0.295374C16.0985 0.689332 16.0985 1.32794 15.7046 1.72189L6.37675 11.0484C6.05587 11.3698 5.6203 11.5504 5.16613 11.5502Z"
                                fill="#28A526"
                            />
                        </svg>
                    </div>
                </div>
                <p className={`font-['Poppins',sans-serif] font-normal leading-[0.75rem] text-[0.583rem] ${dotColor === 'yellow' ? 'text-[#616161]' : 'text-black'} min-w-0`}>{value}</p>
            </div>
        </div>
    )
}
export default FieldItem
